import(/* webpackMode: "eager" */ "/opt/gitco/mm-bond-cancellation/solid-ui/app/error.tsx");
